export default __webpack_public_path__ + "media/images/icons/logo-44734b7c895e4e58742412f21878248d.png";